type EventData = {
    pardotIframeHeightEvent?: number
}

type Event = {
    data?: EventData
    origin: string
}
export const handleIframeHeight =
    (setHeight: (height: number) => void) =>
    (e: Event): void => {
        /*
            TODO: if we use different pardot for other organization then 
                we need add pardot base url in organization
        */
        e.data &&
            e.data.pardotIframeHeightEvent &&
            'https://go.icontainers.com' === e.origin &&
            setHeight(e.data.pardotIframeHeightEvent)
    }
